import React from "react";
import { EuiFormRow, EuiFieldPassword } from "@elastic/eui";
import _ from "lodash";

function AbstractPassword({ options, errors, entityObject = {}, register }) {
    return (
        <EuiFormRow
            label={options.label}
            key={options.name}
            fullWidth
            helpText={options.helpText}
            isInvalid={!_.isNil(errors[options.name])}
            defaultValue={entityObject[options.name]}
            error={options.errorMessage}
        >
            <EuiFieldPassword
                fullWidth
                name={options.name}
                defaultValue={entityObject[options.name]}
                autoComplete="off"
                inputRef={
                    entityObject.id
                        ? register({
                              required: false,
                          })
                        : register({
                              ...options.validation,
                          })
                }
            />
        </EuiFormRow>
    );
}

export default AbstractPassword;
